import { MainPodcastsListWrapper } from "./MainPodcastsListWrapper";

export default MainPodcastsListWrapper;
